import React, { useContext, useState } from "react";
import { FormContext } from "../form_buttons";
import { FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { Box } from "@mui/system";
import { fieldMarginBottom } from "../../form_constants";

interface FormToggleProp {
    field: string;
    label: string;
    onChange?: (checked: boolean) => void;
    /** No se puede cambiar (lo fija otro campo del formulario). */
    disabled?: boolean;
    helperText?: string;
}

const FormToggle = ({ field, label, onChange, disabled, helperText }: FormToggleProp) => {
    const formContext = useContext(FormContext);
    const form = formContext.form;
    const modelField = form.field(field);

    const [modelValue, setModelValue] = useState<boolean>(modelField.valueAsBoolean());
    form.register(field, () => modelValue, t => setModelValue(!!t));

    const handleChange = (checked: boolean) => {
        setModelValue(checked);
        form.notifyFieldChange(field, checked);
        onChange?.(checked);
    };

    return (
        <Box className={["form-input", "form-input-" + field].join(" ")} mb={fieldMarginBottom}>
            <FormControlLabel
                control={
                    <Switch
                        checked={modelValue}
                        disabled={disabled}
                        onChange={e => handleChange(e.target.checked)}
                        id={field}
                    />
                }
                label={label}
            />
            {helperText && <FormHelperText sx={{ mt: 0 }}>{helperText}</FormHelperText>}
        </Box>
    );
};

export default FormToggle;
